module.exports = __webpack_public_path__ + "img/avalon.84eaec36.png";